import { useOverlays } from "contexts/OverlayContext";
import { EnableChartOfAccountsModal } from "./EnableChartOfAccountsModal";

export const EnableChartOfAccountsModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"enableChartOfAccounts">(
        "enableChartOfAccounts",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <EnableChartOfAccountsModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            accounts={overlayInfo.data.accounts}
        />
    );
};
